import React, { useState, useEffect } from "react";
import {
  AppBar,
  Typography,
  Button,
  Toolbar,
  Box,
  LinearProgress,
  createTheme,
} from "@mui/material";
import { NoContent } from "../../../common/NoContent";
import { Download } from "../../../common/Download";
import { useSelector, useDispatch } from "react-redux";
import { InputPagination } from "../../../common/InputPagination";
import Panel from "./Panel";
import { getAnnotationEvents, getProjects } from "../../../redux/actions";

const theme = createTheme();

const useStyles = {
  pages: {
    position: "relative",
    zIndex: 0,
    padding: theme.spacing(2),
    left: 0,
    right: 0,
  },
};

export default function Annotation({ pid, type }) {

  const [isLoading, setIsLoading] = useState(true);

  const events = useSelector((state) =>
    state.cada.ann_events[pid] ? state.cada.ann_events[pid] : null
  );
  const user = useSelector((state) => state.main.user);
  const project = useSelector((state) => state.cada.userProjects[pid]);

  const form = project?.forms?.length > 0
    ? project.forms.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]
    : null;

  const dispatch = useDispatch();

  const [eIdx, setEIdx] = useState(0);

  useEffect(() => {
    if (!project) {
      dispatch(getProjects());
    }
    if (!events || events.length === 0) {
      console.log("Fetching annotation events...");
      dispatch(getAnnotationEvents(pid, user.id, null, true));
    }
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, setIsLoading, pid, user]);

  const handlePageChange = (e, page) => {
    setEIdx(page - 1);
  };

  const handleInputPage = (page) => {
    if (page <= 1) {
      setEIdx(0);
      return;
    }
    if (page > events.false.length + events.true.length) {
      setEIdx(events.false.length + events.true.length - 1);
      return;
    }
    setEIdx(page - 1);
  };

  if (isLoading) {
    return (
      <Box sx={{ width: "100%" }}>
        <LinearProgress />
      </Box>
    );
  }

  return (
    <>
      {events && Object.keys(events).length > 0 ? (
        <div style={{ height: "calc(100vh - 250px)" }}>
          <AppBar
            component="div"
            sx={{ pl: 1 }}
            position="static"
            elevation={0}
          >
            <Toolbar>
              <Typography color="inherit" variant="h6" component="h1">
                {project?.name} Annotation
              </Typography>
              <div style={{ flex: "1 1 auto" }} />
              <Download
                data={[...events[true], ...events[false]]
                  .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))
                  .filter(
                    (e) => e.cadaAnnotations[0].cadaAnnotationValues.length > 0
                  )
                  .map((event) => {
                    const groupedByField =
                      event.cadaAnnotations[0].cadaAnnotationValues.reduce(
                        (acc, obj) => {
                          const field = obj.field;

                          // Check if the field already exists in the accumulator
                          if (!acc[field] || obj.id > acc[field].id) {
                            acc[field] = obj; // Replace with the current object if it has a higher id or does not exist in the accumulator
                          }

                          return acc;
                        },
                        {}
                      );

                    return Object.values(groupedByField).map((item) => ({
                      user: user.email,
                      file: event.cadaFile.path,
                      field: item.field,
                      createAt: item.createdAt,
                      value: item.value,
                    }));
                  })}
              />
              <Button variant="outlined" color="inherit" size="small">
                Report
              </Button>
            </Toolbar>
          </AppBar>
          <AppBar
            component="div"
            sx={{ px: 1, height: 10 }}
            position="static"
            elevation={0}
          />
          {/* <Panel
            events={[...events[true], ...events[false]].sort((a, b) => {
              const getNumber = (path) => {
                // Extract the numeric part from the file path
                const match = path.match(/(\d+)\.json$/);
                return match ? parseInt(match[1], 10) : 0; // Default to 0 if no match
              };

              const numA = getNumber(a.cadaFile.path);
              const numB = getNumber(b.cadaFile.path);

              return numA - numB;
            })}
            eIdx={eIdx}
            setEIdx={setEIdx}
            user={user}
            project={project}
            aNotes={annotatedNotes}
            setAnnotatedNotes={setAnnotatedNotes}
          /> */}
          <Panel
            events={[...events[true], ...events[false]]}
            eIdx={eIdx}
            setEIdx={setEIdx}
            user={user}
            project={project}
            form={form}
            type={type}
          />
          <Box sx={{ ...useStyles.pages }}>
            <InputPagination
              total={events.false.length + events.true.length}
              page={eIdx + 1}
              onChange={handlePageChange}
              onInput={handleInputPage}
            />
          </Box>
        </div>
      ) : (
        <NoContent
          text="There are no assignments!"
          subtext="Contact your admin for assignments!"
        />
      )}
    </>
  )
}
